import { always, equals, ifElse } from 'ramda';

import { WIDTH_TYPES } from '../../../utils/constants';
import { BRAND_COLORS, TRANSPARENT, MAP_BACKGROUND_COLOR } from '../../../utils/colors';
import { OMITTED_TERRITORIES } from '../mapChart/mapChart.constants';
import { barChartRenderer } from '../tooltip/contentRenderers/barChart.renderer';

const LEGEND = ['Highest Score', ['A', 'B+', 'B', 'C+', 'C', 'D+', 'D*\nNR'], 'Lowest Score'];

const CRISIS_BUDGETING_LEGEND = ['Highest % SBL Gain', 'Lowest % SBL Loss', 'Did not adapt SBL']

export const MAP_DEFAULT = {
  tooltipContentRenderer: () => null,
  titlesVisibility: true,
  omittedTerritories: OMITTED_TERRITORIES,
  // COLORS
  background: TRANSPARENT,
  noDataColor: '#eee',
  colors: BRAND_COLORS,
  stroke: TRANSPARENT,
  strokeWidth: 0.5,
  graticuleVisible: false,
  graticuleStroke: '#00000008',
  graticuleStrokeWidth: 1,
  graticuleFill: '#ebeef144',
  xAngleOffset: 0,
  yAngleOffset: 0,
  // LEGEND
  legendVisibility: true,
  legendStructure: LEGEND
};

export const CRISIS_DEFAULT = {
  tooltipContentRenderer: () => null,
  titlesVisibility: true,
  omittedTerritories: OMITTED_TERRITORIES,
  // COLORS
  background: TRANSPARENT,
  noDataColor: '#eee',
  noScore: '#000',
  colors: BRAND_COLORS,
  stroke: TRANSPARENT,
  strokeWidth: 0.5,
  graticuleVisible: false,
  graticuleStroke: '#00000008',
  graticuleStrokeWidth: 1,
  graticuleFill: '#ebeef144',
  xAngleOffset: 20,
  yAngleOffset: 20,
  // LEGEND
  legendVisibility: true,
  legendStructure: CRISIS_BUDGETING_LEGEND,
};

export const getMapConfig = (type, isMobile) => {
  const condConfig = ifElse(
    equals(WIDTH_TYPES.SHORT),
    always({
      xAngleOffset: 15,
      yAngleOffset: 11.5,
      type,
    }),
    always({
      omittedTerritories: [],
      graticuleVisible: true,
      noDataColor: '#68686812',
      graticuleStroke: '#00000015',
      graticuleFill: TRANSPARENT,
      strokeWidth: 1,
      stroke: MAP_BACKGROUND_COLOR,
      type,
    })
  )(type);

  return {
    ...condConfig,
    tooltipContentRenderer: barChartRenderer,
    minValue: 0,
    maxValue: 4,
    chartHeight: isMobile ? 260 : 504,
  };
};
